import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { FxButtonBase } from "../../fxms/inputs/FxButton";
import { FxLabelBase } from "../../fxms/inputs/FxLabel";
import { FxFileLink } from "../../fxms/inputs/FxFileLink";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxWindow } from "../../fxms/windows/FxWindows";

/*관리자페이지> Q&A 화면 */
export const UI_5_4_CU = (props) => {
  const user = FxmsData.getUser();

  const [selectedData, setSelectedData] = useState({});
  const [replyMode, setReplyMode] = useState(false);
  const [qnaAnser, setQnaAnser] = useState('');
  const [qnaStatus, setQnaStatus] = useState('');
  const [selectedUploadedFiles, setSelectedUploadedFiles] = useState([]);

  useEffect(() => {    
    setSelectedUploadedFiles(props.selectedData.files);
    setSelectedData(props.selectedData);
    setQnaStatus(props.selectedData.answerStCd); // answerStCd 값으로 초기 상태 설정
    setQnaAnser(props.selectedData.answerCnts); // answerCnts 값으로 초기 상태 설정
  }, []);


  const sendEmail = async (qnaEmail, qnaTitle, qnaAnser) => {
    const subject = `${qnaTitle} 문의에 대한 답변입니다.`;
    const bodyHtml = `
<div style="font-family:'Noto Sans KR','Apple SD Gothic Neo',sans-serif;font-size:14px;color:#222;line-height:1.6;margin:0;">
  <p style="margin:0 0 12px;">안녕하세요,</p>
  <p style="margin:0 0 12px;">${user?.userName || ''}으로부터 문의하신 내용에 답변이 등록되었습니다.</p>
  <p style="margin:0 0 12px;">답변내용은 홈페이지에서 확인해주세요.</p>
  <p style="margin:0 0 16px;">감사합니다.</p>
  <p style="margin:0;">${user?.userName || ''} 드림</p>
</div>
`.trim();

    const payload = {
      to: qnaEmail,
      subject,
      message: bodyHtml,
      isHtml: true,
    };

    try {
      await FxmsData.POST("open/mail", payload);
      console.log("이메일 전송 성공");
    } catch (error) {
      console.log("이메일 전송 실패:", error);
      throw error;
    }
  };

  const onRegister = async() => {
    // 유효성 검사
    if(!qnaAnser) {  // 빈 문자열이나 undefined 모두 체크
      FxWindow.alert("답변을 입력해주세요.");
      return;
    }

    if(!qnaStatus) {  // 빈 문자열이나 undefined 모두 체크
      FxWindow.alert("처리상태를 선택해주세요.");
      return;
    }
    
    // 공통으로 사용되는 파라미터
    const params = {
      qnaMenuClCd: selectedData.qnaMenuClCoNo,
      qnaTitle: selectedData.qnaTitle,
      qnaNo: selectedData.qnaNo,
      qnaCnts: qnaAnser,
      qnaStCd: qnaStatus,
      qnaEmail: selectedData.qnaEmail,
    };

    const saveData = async () => {
    try {
      await FxmsData.POST("vup/add_5_4", params);
      
      if (qnaStatus === "Y") {
        try {
          await sendEmail(selectedData.qnaEmail, selectedData.qnaTitle, qnaAnser);
          FxWindow.alert("답변이 저장되었고 이메일이 발송되었습니다.");
        } catch (error) {
          FxWindow.alert("답변은 저장되었으나 이메일 발송에 실패했습니다.");
        }
      } else {
        FxWindow.alert("정상적으로 저장되었습니다.");
      }
      
      setSelectedData({
        ...selectedData,
        answerCnts: qnaAnser,
        answerStCd: qnaStatus,
        qnaStCd: qnaStatus === "Y" ? "답변완료" : "답변대기"
      });
      setReplyMode(false);
    } catch (e) {
    console.log("저장 실패 ........", e);
        FxWindow.alert("저장에 실패했습니다.");
      }
    };

    // 답변 완료 상태일 경우 확인 창 표시
    if(qnaStatus === "Y") {
      FxWindow.confirm("답변 완료 시 등록자 이메일로 답변완료 안내 이메일이 발송됩니다. 저장하시겠습니까?", async (result) => {
        if (result) await saveData();
      });
    } 
    if(qnaStatus === "P") {
      await saveData();
    }
  }

  const onList = () => {
    if (props.refershGridData) {
      props.refershGridData();
    }
    if (props.onCloseBtnClick) {
      props.onCloseBtnClick();
    }
  }

  const onReply = () => {
    setReplyMode(true);
  }

  const onEditReply = () => {
    setReplyMode(true);
  }

  const onEdit = async() => {
    const uri = "vup/update_5_4";

    const params = {
      qnaNo: selectedData.qnaNo,
      qnaCnts: qnaAnser,
      qnaStCd: qnaStatus,
    }
    
    const saveData = async () => {
      try {
        await FxmsData.PUT(uri, params);
        
        if (qnaStatus === "Y") {
          try {
            await sendEmail(selectedData.qnaEmail, selectedData.qnaTitle, qnaAnser);
            FxWindow.alert("답변이 수정되었고 이메일이 발송되었습니다.");
          } catch (error) {
            FxWindow.alert("답변은 수정되었으나 이메일 발송에 실패했습니다.");
          }
        } else {
          FxWindow.alert("정상적으로 수정되었습니다.");
        }
        
        setSelectedData({
          ...selectedData,
          answerCnts: qnaAnser,
          answerStCd: qnaStatus,
          qnaStCd: qnaStatus === "Y" ? "답변완료" : "답변대기"
        });
        setReplyMode(false);
      } catch (e) {
        console.log("수정 실패 ........", e);
        FxWindow.alert("수정에 실패했습니다.");
      }
    };

    // 답변 완료 상태일 경우 확인 창 표시
    if(qnaStatus === "Y") {
      FxWindow.confirm("답변 완료 시 등록자 이메일로 답변완료 안내 이메일이 발송됩니다. 저장하시겠습니까?", async (result) => {
        if (result) await saveData();
      });
    } 
    if(qnaStatus === "P") {
      await saveData();
    }
  }

  const onDelete = async() => {
    FxWindow.confirm("문의를 삭제하시겠습니까?", async (result) => {
      if (result) {
        const qnaNo = selectedData.qnaNo;
        const uri = "vup/delete_5_4/" + qnaNo;
        try {
          const res = await FxmsData.DELETE(uri);

          FxWindow.alert("정상적으로 삭제되었습니다.", () => {
            onList();
          });
        } catch (e) {
          console.log("삭제 실패 ........", e);
        }
      }
    });
  }

  const onCancel = () => {
    setReplyMode(false);
  };

  const onChangeQnaAnser = (e) => {
    setQnaAnser(e.target.value);
  };

  const handleStatusChange = (e) => {
    setQnaStatus(e.target.value);
  };

  return (
    <div>
      <div className="FxDataEdit">
        <table className="table">
          <colgroup>
            <col style={{ width: "15%" }} />
            <col style={{ width: "35%" }} />
            <col style={{ width: "15%" }} />
            <col style={{ width: "35%" }} />
          </colgroup>
          <tbody>
            <tr>
              <th>산업단지명</th>
              <td>
                <input
                  className="complexInloName"
                  type="text"
                  name="complexInloName"
                  value={selectedData?.complexInloName}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
              <th>회사명</th>
              <td>
                <input
                  className="companyInloName"
                  type="text"
                  name="companyInloName"
                  value={selectedData?.companyInloName}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
            </tr>
            <tr>
              <th>사업장명</th>
              <td>
                <input
                  className="plantInloName"
                  type="text"
                  name="plantInloName"
                  value={selectedData?.plantInloName}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
              <th>등록자</th>
              <td>
                <input
                  className="regUserName"
                  type="text"
                  name="regUserName"
                  value={selectedData?.regUserName}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
            </tr>
            <tr style={{ height: '15px' }}></tr> {/* 여백 추가 */}
            <tr>
              <th>문의분류</th>
              <td colSpan="3">
                <input
                  className="qnaMenuClCd"
                  type="text"
                  name="qnaMenuClCd"
                  value={selectedData.qnaMenuClCd}
                  disabled={true}
                  style={{ width: '200px%', height: '30px' }}
                />
              </td>
            </tr>
            <tr>
              <th>제목</th>
              <td colSpan="3">
                <input
                  className="qnaTitle"
                  type="text"
                  name="qnaTitle"
                  value={selectedData.qnaTitle}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
            </tr>
            <tr>
              <th>내용</th>
              <td colSpan="3">
                <textarea
                  className="qnaCnts"
                  name="qnaCnts"
                  rows={4}
                  value={selectedData.qnaCnts}
                  disabled={true}
                  style={{ width: '100%' }}
                />
              </td>
            </tr>
            <tr>
              <th>이메일</th>
              <td colSpan="3">
                <input
                  className="qnaEmail"
                  type="email"
                  name="qnaEmail"
                  value={selectedData.qnaEmail}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
            </tr>
            <tr>
              <th><FxLabelBase>첨부</FxLabelBase></th>
              <td>
              {selectedUploadedFiles && selectedUploadedFiles.length > 0 ? (
                selectedUploadedFiles.map((item, index) => (
                  <span key={index}>
                    <FxFileLink 
                      fileId={item.fileId} 
                      fileUrl={'8_1'} 
                      orgNm={item.name}
                    />
                    {index < selectedUploadedFiles.length - 1 && ' '}
                  </span>
                ))
              ) : (
                <input
                  type="text"
                  value="첨부파일이 없습니다."
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
                )}
              </td>
            </tr>
            <tr>
              <th><FxLabelBase>등록일시</FxLabelBase></th>
              <td>
                <input
                  className="regDtm"
                  type="text"
                  name="regDtm"
                  value={selectedData.regDtm}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
            </tr>
            <tr>
              <th><FxLabelBase>진행상태</FxLabelBase></th>
              <td> 
                <input 
                  className="qnaStCd" 
                  name="qnaStCd" 
                  value={selectedData.answerStCd ? selectedData.answerStCd === "P" ? "처리 중" : "답변 완료" : "답변 대기"} 
                  disabled={true} 
                  style={{ height: '30px' }} 
                />
              </td>
            </tr>
            {!replyMode ? (
                // 읽기 전용
                selectedData.answerCnts && (
                  <>
                    <tr>
                      <th><FxLabelBase>답변</FxLabelBase></th>
                      <td colSpan="3"> 
                        <textarea 
                          className="answerCnts" 
                          name="answerCnts" 
                          value={selectedData.answerCnts} 
                          disabled={true} 
                          style={{ width: '100%', height: '30px' }} 
                        />
                      </td>
                    </tr>
                </>
              ) ): (
                // 답변등록 모드
                <>
                  <tr>
                    <th><FxLabelBase>답변</FxLabelBase></th>
                    <td colSpan="3"> 
                      <textarea 
                        className="qnaAnser" 
                        name="qnaAnser" 
                        value={qnaAnser} 
                        onChange={onChangeQnaAnser} 
                        style={{ width: '100%', height: '30px' }} 
                      />
                    </td>
                  </tr>
                  <tr>
                    <th><FxLabelBase>처리상태</FxLabelBase></th>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                        <label style={{ 
                          display: 'flex', 
                          alignItems: 'center',
                          fontSize: '14px',  // 글자 크기 조정
                          color: '#fff'      // 흰색 텍스트
                        }}>
                          <input
                            type="radio"
                            value="P"
                            checked={qnaStatus === "P"}
                            onChange={handleStatusChange}
                            style={{ 
                              width: '15px', 
                              height: '15px',
                              marginRight: '8px'
                            }}
                          />
                          처리 중
                        </label>
                        <label style={{ 
                          display: 'flex', 
                          alignItems: 'center',
                          fontSize: '14px',  // 글자 크기 조정
                          color: '#fff'      // 흰색 텍스트
                        }}>
                          <input
                            type="radio"
                            value="Y"
                            checked={qnaStatus === "Y"}
                            onChange={handleStatusChange}
                            style={{ 
                              width: '15px', 
                              height: '15px',
                              marginRight: '8px'
                            }}
                          />
                          답변 완료
                        </label>
                      </div>
                    </td>
                  </tr>
                </>
              )}
          </tbody>
        </table>
      </div>
      <div className="FxCrudToolbar">
        {!replyMode && <div className="FxFilterCenter">
          <FxButtonBase key={uuidv4()} name="click" onClick={onList} text="목록" />
        </div>}
        <div className="FxFilterRight">          
          {replyMode ? 
            <>
              <FxButtonBase 
                key={uuidv4()} 
                name="click" 
                onClick={selectedData.answerCnts ? onEdit : onRegister} 
                text={selectedData.answerCnts ? "수정 완료" : "저장"} 
              />
              <FxButtonBase key={uuidv4()} name="click" onClick={onCancel} text="취소" />
            </>      
            :
            <>
              <FxButtonBase 
                key={uuidv4()} 
                name="click" 
                onClick={selectedData.answerCnts ? onEditReply : onReply} 
                text={selectedData.answerCnts ? "답변수정" : "답변등록"} 
              />
              <FxButtonBase key={uuidv4()} name="click" onClick={onDelete} text="삭제" />
            </>
          }
        </div>
        
      </div>
    </div>
  )
}
